import { Col, Container, Image, Row } from "react-bootstrap";
import * as yup from "yup";
import { PHONE_REGEX, toWebp } from "../../../utils/common";
import dynamic from "next/dynamic";

const BannerHireNowForm = dynamic(() => import('../../forms/banner-hire-now-form'));

const options = [
  { value: "chocolate", label: "Chocolate" },
  { value: "strawberry", label: "Strawberry" },
  { value: "vanilla", label: "Vanilla" },
];

let baseUrl = process.env.NEXT_PUBLIC_REACT_APP_RESOURCE_BASE_URL;

const Contact = ({ data }) => {
	const bannerFormSchema = yup
		.object({
			employee_name: yup.string().required("Name is required."),
			employee_email: yup
				.string()
				.email("Email is not valid.")
				.required("Email is required."),
			contact_no: yup
				.string()
				.min(10, "Invalid phone number")
				.max(13, "Invalid phone number")
				.matches(PHONE_REGEX, "Invalid phone number"),
			company_name: yup.string(),
			requirements: yup.string().required("Requirements are required."),
		})
		.required();

	const bannerFormInitialValues = {
		employee_name: "",
		employee_email: "",
		contact_no: "",
		company_name: "",
		requirements: "",
	};

  return (
    <section className="contact-new-section technology-cobntact-section bg-one home-padding-new">
      <Container>
        <Row>
          <Col lg={6} md={5}>
            <div className="contact-left-content">
              <h2 className="text-black">{data?.title}</h2>

              <ul>
                {data?.buttons?.map((button) => (
                  <li key={button?.id}>
                    <a href={button?.href} className="text-large font-semibold text-black">
                      <div className="call-icon">
                        <Image
                          src={toWebp(`${baseUrl}${button?.image?.data?.attributes?.url}`)}
                          alt={button?.image?.data?.attributes?.name}
                        />
                      </div>{" "}
                      {button?.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </Col>
          <Col lg={6} md={7}>
            <div className="contact-right-form bg-white border-2 border-color">
              <h3 className="text-large font-semibold text-black">{data?.form_title}</h3>
              <BannerHireNowForm
                schema={bannerFormSchema}
                initialValues={
                  bannerFormInitialValues
                }
                isNew={true}
              />
              {/* <Row>
                <Col lg={6} md={6}>
                  <div className="form-group form-floating">
                    <Field
                      className="form-control"
                      name="employee_name"
                      placeholder="Full name*"
                    />
                    <label htmlFor="employee_name" className="form-label">
                      Full name*
                    </label>
                  </div>
                </Col>
                <Col lg={6} md={6}>
                  <div className="form-group form-floating">
                    <Field
                      className="form-control"
                      name="employee_name"
                      placeholder="Full name*"
                    />
                    <label htmlFor="employee_name" className="form-label">
                      Email*
                    </label>
                  </div>
                </Col>
                <Col lg={6} md={6}>
                  <div className="form-group form-floating">
                    <Field
                      className="form-control"
                      name="employee_name"
                      placeholder="Full name*"
                    />
                    <label htmlFor="employee_name" className="form-label">
                      Phone number*
                    </label>
                  </div>
                </Col>
                <Col lg={6} md={6}>
                  <div className="form-group form-floating">
                    <Field
                      className="form-control"
                      name="employee_name"
                      placeholder="Full name*"
                    />
                    <label htmlFor="employee_name" className="form-label">
                      Country*
                    </label>
                  </div>
                </Col>
                <Col lg={12} md={12}>
                  <div className="form-group form-floating">
                    <Field
                      as="textarea"
                      type="text"
                      className="form-control"
                      name="requirements"
                      id="requirements"
                      placeholder="Write job description"
                    />
                    <label htmlFor="requirements" className="form-label">
                      Project description*
                    </label>
                    <ErrorMessage
                      className="error-message"
                      name="requirements"
                      component="span"
                      style={{
                        color: "red",
                      }}
                    />
                  </div>
                </Col>

                <Col lg={7}>
                  <div className="sign-nda">
                    <a href="#">
                      <Image src="/images/home/tick-circle.svg" alt="" /> 100%
                      confidential{" "}
                    </a>
                    <a href="#">
                      <Image src="/images/home/tick-circle.svg" alt="" /> We
                      sign NDA{" "}
                    </a>
                  </div>
                </Col>
                <Col lg={5}>
                  <div className="budget-btn">
                    <button className="btn btn-primary"> Submit </button>
                  </div>
                </Col>
              </Row> */}
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Contact;
